import React, { Component } from "react"
import "./index.scss"

class InputField extends Component {
  render() {
    const {
      label,
      type,
      placeholder,
      error = "",
      value = "",
      name,
      disabled,
      handleChange,
      customIcon,
      caption,
      appendIcon,
      ...props
    } = this.props

    let hasError = Boolean(error) && !disabled

    return type === "textarea" ? (
      <div className="input-field">
        <label className="label">{label}</label>
        <textarea
          className={`textarea ${hasError ? "has-error" : ""}`}
          placeholder={placeholder}
          name={name}
          value={value}
          onChange={handleChange}
          {...props}
        />

        {hasError && <p className="error-message">{`* ${error}`}</p>}
      </div>
    ) : (
      <div className="input-field">
        <label className="label">{label}</label>
        <input
          className={`input ${hasError ? "has-error" : ""}`}
          type={type}
          placeholder={placeholder}
          name={name}
          value={value}
          onChange={handleChange}
          customicon={customIcon}
          {...props}
        />
        {/* <label className="input-label">{label}</label> */}
        {appendIcon}
        {caption && <p className="input-caption">{caption}</p>}
        {hasError && <p className="error-message">{`* ${error}`}</p>}
      </div>
    )
  }
}

export default InputField
